import { api } from '@services';

import qs from 'query-string';

import Update, {
  IUpdateRawQueryList,
  IUpdateRawQueryListApiModel,
} from '@models/Update.model';

interface IRequest {
  equipmentId: string;
  search: string;
}

const getEquipmentUpdates = async ({
  equipmentId,
  search,
}: IRequest): Promise<IUpdateRawQueryList[]> => {
  const query = {
    q: search,
  };

  const queryString = qs.stringify(query);

  const { data: updateStatuses } = await api.get<IUpdateRawQueryListApiModel[]>(
    `/equipments/${equipmentId}/updates?${queryString}`,
  );

  return Update.arrayFromRawQueryListApiModel(updateStatuses);
};

export { getEquipmentUpdates };
